export const NO_ACTIONS_SCREENS = ['review', 'completion'];
export const ScreenTypes = {
    instruction: 'Instruction',
    vrs: 'VRS',
    nrs: 'NRS',
    vas: 'VAS',
    nde: 'NDE',
    date_time: 'Date/Time Entry',
    eqvas: 'EQVAS',
    text_input: 'Text Input',
    searchable_vrs: 'Searchable VRS',
    placeholder: 'Placeholder',
    dynamic_vrs: 'Dynamic VRS',
    image_choice: 'Image Choice',
    tlfb: 'Timeline Followback',
    body_map: 'Body Map',
};
export var UrlScreenModalActions;
(function (UrlScreenModalActions) {
    UrlScreenModalActions["VIEW"] = "view";
    UrlScreenModalActions["EDIT"] = "edit";
    UrlScreenModalActions["ADD"] = "add";
    UrlScreenModalActions["BRANCHING"] = "branching";
    UrlScreenModalActions["BRANCHING_EDIT"] = "branching_edit";
    UrlScreenModalActions["CDASH"] = "cdash";
    UrlScreenModalActions["CDASH_EDIT"] = "cdash_edit";
    UrlScreenModalActions["MOVE"] = "move";
})(UrlScreenModalActions || (UrlScreenModalActions = {}));
export const screenTemplateVersionByType = {
    body_map: '1.0',
    image_choice: '1.0',
    searchable_vrs: '1.0',
    tlfb: '1.0',
};
